import { useFeatureFlag } from '~/shared/hooks/useFeatureFlag'
import { LUCI_FLAG } from './constants'

/** Whether this staff member may see Luci; a missing flag row or an unenrolled user reads false. */
export const useLuci = () => useFeatureFlag(LUCI_FLAG)
